<div class="privacy-more-info">
	<p class="privacy-more-info__text">
		{{ 'PRIVACY_POLICY.MORE_INFO.GLOBAL_NOTE' | translate }}
		<a class="privacy-more-info__link" [href]="'PRIVACY_POLICY.URLS.ENELX_URL' | translate" target="_blank" rel="noopener noreferrer">{{ 'PRIVACY_POLICY.URLS.ENELX_URL_LABEL' | translate }}</a>
		{{ 'PRIVACY_POLICY.MORE_INFO.GLOBAL_NOTE_AFTER' | translate }} 
	</p>

	@if (isUsLocale()) {
	<div class="privacy-more-info__us">
		<p class="privacy-more-info__text privacy-more-info__us-title">
			<b>{{ 'PRIVACY_POLICY.MORE_INFO.US_TITLE' | translate }}</b>
		</p>
		<p class="privacy-more-info__text privacy-more-info__us-ccpa-title">
			<b>{{ 'PRIVACY_POLICY.MORE_INFO.US_CCPA_TITLE' | translate }}</b>
		</p>
		<p class="privacy-more-info__text privacy-more-info__us-ccpa-text">
			<a class="privacy-more-info__link" href="https://www.enelx.com/ccpa-privacy-policy" target="_blank" rel="noopener noreferrer">
				{{ 'PRIVACY_POLICY.MORE_INFO.US_CLICK_HERE' | translate }}
			</a>
			{{ 'PRIVACY_POLICY.MORE_INFO.US_CCPA_PRIVACY_LINK' | translate }}<br />
			<a class="privacy-more-info__link" href="https://www.enelx.com/notice-at-collection" target="_blank" rel="noopener noreferrer">
				{{ 'PRIVACY_POLICY.MORE_INFO.US_CLICK_HERE' | translate }}
			</a>
			{{ 'PRIVACY_POLICY.MORE_INFO.US_NOTICE_AT_COLLECTION' | translate }}
	</div>
	}
</div>